import { Input, Modal } from 'antd'
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

function NameModal(props) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");

    useEffect(
        () => {
            if (props.open) {
                setName(props.value.name);
            }
        }, [props.open, props.value.name]
    )

    const saveName = () => {
        setLoading(true);

        const data = {
            callLegId: props.value.id,
            name: name
        }

        axios.post("/active/name", data)
            .then(
                res => {
                    if (res.status === 200) {
                        props.isRefresh();
                        props.close();
                    }
                }
            )
            .finally(
                () => {
                    setLoading(false);
                }
            )
    }

    return (
        <Modal
            centered
            title={t("LABEL.TITLE.CHANGE_MEETING_TITLE")}
            open={props.open}
            onCancel={props.close}
            okText={t("BTN.SAVE")}
            onOk={saveName}
            okButtonProps={{
                loading: loading
            }}
            cancelText={t("common.button.cancel")}
            cancelButtonProps={{
                loading: loading
            }}
        >
            <Input
                value={name}
                onChange={e => setName(e.target.value)}
                disabled={loading}
                onKeyDown={
                    e => {
                        if (e.key === "Enter") {
                            saveName();
                        }
                    }
                }
            />
        </Modal>
    )
}

export default NameModal
